module.exports = __webpack_public_path__ + "static/media/artboard_1 (1) 2.d39777f8.png";